import React from 'react';

const CallToAction = ({ onNavigate }) => {
  return (
    <section className="py-16 bg-purple-600 text-white text-center">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold mb-4">Conviértete en instructor hoy</h2>
        <p className="text-lg mb-8">
          Únete a miles de instructores y enseña lo que sabes a millones de estudiantes.
        </p>
        <button
          onClick={() => onNavigate('registerInstructor')} // Navegar al formulario de registro de instructor
          className="bg-white text-purple-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
        >
          Empieza a enseñar
        </button>
      </div>
    </section>
  );
};

export default CallToAction;